/* eslint-disable prettier/prettier */
import { BRAND_PROFILES } from './brand-profiles';

export const environment = {
  production: false,
  brandProfiles: BRAND_PROFILES,
  apiUrlIdentity: 'https://asv-identity-backend-main.k3s.flycatchtech.in',
  apiUrlSms:
    'https://asv-sms-notification-service-backend-dev.k3s.flycatchtech.in',
};
